module.exports = __webpack_public_path__ + "img/9.18e21ef2.jpg";